import { useMemo } from 'react';

import useAppointmentStore, {
  isInBranchAppointment as isInBranchSelector,
  isOnlineAppointment as isOnlineSelector,
} from '@/store/AppointmentStore';

const useFallbackWorkTypeId = (): string => {
  const isInBranch = useAppointmentStore(isInBranchSelector);
  const isOnline = useAppointmentStore(isOnlineSelector);
  const destinations = useAppointmentStore((state) => state.destinations);

  return useMemo(() => {
    if (isOnline) {
      return (
        destinations.find((destination) => destination.name === 'Other')
          ?.workTypeId ?? ''
      );
    }

    if (isInBranch) {
      return (
        destinations.find(
          (destination) =>
            destination.destinationApiName === 'United_States_&_Canada',
        )?.workTypeId ?? ''
      );
    }

    return '';
  }, [isInBranch, isOnline, destinations]);
};

export default useFallbackWorkTypeId;
